<!--
  Esta es la plantilla que se usa para las páginas que pertenecen al panel
-->
<template>
  <v-main>
    <!-- menu lateral / drawer -->
    <v-navigation-drawer
      v-model="menuLateral"
      fixed
      temporary
      overlay-color="#000000"
      overlay-opacity="0.7"
      width="320" 
    >
      <v-list-item class="mt-15" @click="$router.push({ name: 'userdata' })">
        <v-list-item-avatar>
          <v-img src="@/assets/avatar.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
              {{this.$store.state.usuario.nombre}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{this.$store.state.usuario.rol}}
          </v-list-item-subtitle>
        </v-list-item-content>
        
      </v-list-item>

      <v-divider></v-divider>

      <span v-for="elemento in elementosMenuUsuario" :key="elemento.titulo">
        <v-list-item link :to="elemento.ruta" replace>
          <v-list-item-icon>
            <v-icon>{{ elemento.icono }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ elemento.titulo }} 
              <v-badge
                v-if="elemento.esMenuAlertas"
                color="error"
                :offset-x="-5"
                :content="$global.numeroAlertasPendientes"
                :value="$global.numeroAlertasPendientes > 0"
              ></v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </span>

      <template v-slot:append>
        
        <v-list-item link to="/panel/acercaDe" replace>
          <v-list-item-content>
            <v-list-item-title>Acerca de ...</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      
        <v-divider></v-divider>
        <v-list-item link to="/panel/logout" replace>
          <v-list-item-icon>
            <v-icon class="cerrarSesion">mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="cerrarSesion">Cerrar sesión</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <!-- app bar -->
    <v-app-bar v-if="esIOS" fixed color="gray lighten-4" style="height:100px">
      <v-app-bar-nav-icon v-bind:class="getPlatformClass()" v-if="$route.name == 'inicio'" @click="menuLateral=!menuLateral"></v-app-bar-nav-icon>
      <v-btn v-else text fab small class="ml-n2" @click="$router.replace({ name: 'inicio' })">
        <v-icon v-bind:class="getPlatformClass()" >mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <img v-if="!$route.meta.titulo" v-bind:class="getPlatformClass()"
        src="@/assets/logo-rackon2-w-contorno-eq.svg"
        style="margin-bottom: 2px; margin-left:2px; max-height: 50px"
      />
      <span v-bind:class="getPlatformClass()" v-else class="title" >{{ $route.meta.titulo }}</span>
      <v-spacer></v-spacer>
        <!--boton de grabar solo visible en ventanas de User y Sensor -->
      <v-btn :hidden="!isModalFormActive()" @click="saveUserdataMsg" text small fab>
        <v-icon v-bind:class="getPlatformClass()" class="mt-0">mdi-content-save</v-icon>
        </v-btn>         
    </v-app-bar>
    <!-- not v-if="esIOS" -->
    <v-app-bar v-else fixed color="gray lighten-4" style="height:65px">
      <v-app-bar-nav-icon v-bind:class="getPlatformClass()" v-if="$route.name == 'inicio'" @click="menuLateral=!menuLateral"></v-app-bar-nav-icon>
      <v-btn v-else text fab small class="ml-n2" @click="$router.replace({ name: 'inicio' })">
        <v-icon v-bind:class="getPlatformClass()" >mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <img v-if="!$route.meta.titulo" v-bind:class="getPlatformClass()"
        src="@/assets/logo-rackon2-w-contorno-eq.svg"
        style="margin-bottom: 2px; margin-left:2px; max-height: 50px"
      />
      <span v-bind:class="getPlatformClass()" v-else class="title" >{{ $route.meta.titulo }}</span>
      <v-spacer></v-spacer>
        <!--boton de grabar solo visible en ventanas de User y Sensor -->
      <v-btn :hidden="!isModalFormActive()" @click="saveUserdataMsg" text small fab>
        <v-icon v-bind:class="getPlatformClass()" class="mt-0">mdi-content-save</v-icon>
        </v-btn>         
    </v-app-bar>
     
    <!-- contenido de la pagina -->
    <!-- <v-sheet class="overflow-y-auto overflow-x-hidden" style="height: 100vh;" color="transparent"> -->
      <!-- <v-scroll-x-transition hide-on-leave> -->
      <!-- <v-fab-transition> -->
        <router-view v-bind:class="getPlatformClass()"/>        
      <!-- </v-fab-transition> -->
      <!-- </v-scroll-x-transition> -->
    <!-- </v-sheet> -->

    <v-snackbar
      v-for="(notificacion, index) in notificacionesAlerta"
      :key="notificacion.id"
      :value="true"
      :timeout="15000" 
      shaped 
      multi-line
      vertical
      color="#5050a0"
      elevation="8"
      @close="removeFromStore(index)"
      >
      <v-icon class="mr-2">mdi-alert</v-icon><strong>Alerta de Sensor</strong><br><br>
      <span v-html="texto2HTML (notificacion.data.mensaje)"></span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="removeFromStore(index)"
        >
          Entendido
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="cuadroEmergente.mostrar" max-width="400">
          <v-card light>
            <v-card-title class="headline"><v-icon color="#303030" x-large class="mr-2" v-html="cuadroEmergente.icono"></v-icon><span v-html="cuadroEmergente.titulo"></span></v-card-title>
            <v-card-text><span v-html="cuadroEmergente.texto"></span></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="cuadroEmergente.accion()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  </v-main>
</template>

<script>
import { mapState } from "vuex";
import * as Notificaciones from "@/notificaciones.js"
import util from "@/util";

export default {
  
  computed: {
    ...mapState(["usuario"]),
    elementosMenuUsuario() {
      return this.elementosMenu.filter(elemento =>
        elemento.atributoRolUsuarioNecesario
          ? this.usuario.atributosRol.includes(
              elemento.atributoRolUsuarioNecesario
            )
          : true
      );
    },
    isSaveButtonDisabled() {
      if (this.mounted) {
        return !(this.$refs.entryForm.validate());
      }
      return true;
    }
  },

  data: () => ({
    esIOS: null,
    nameRules: [
      v => !!v || 'Campo requerido',
      v => (v && v.length > 5) || 'Necesarios más de 5 caracteres',
    ],
    cuadroEmergente: {
      mostrar: false,
      titulo: "",
      texto: ""
    },
    mounted: false,

    menuLateral: false,
    notificacionesAlerta: [],
    elementosMenu: [
      {
        titulo: "Inicio",
        icono: "mdi-home",
        ruta: "/panel/#"
      },
     {
        titulo: "Alertas",
        icono: "mdi-alarm-light",
        ruta: "/panel/alertas",
        esMenuAlertas: true
      }, 
      {
        titulo: "Gráfica",
        icono: "mdi-chart-bell-curve-cumulative",
        ruta: "/panel/grafica"
      }
    ]
  }),

  methods: {
    isModalFormActive() {
      return ((this.$route.path.indexOf('Sensor')!=-1) || 
              (this.$route.path.indexOf('userdata')!=-1));
    },

    saveUserdataMsg() {
      if (this.$route.path.indexOf('Sensor')!=-1) {
        this.$root.$emit('save:sensordata');
      } else {
        if (this.$route.path.indexOf('userdata')!=-1) {
          this.$root.$emit('save:userdata');
        }
      }
    },

    getPlatformClass(objeto){
      return util.getPlatformClass(objeto);
    },
    getPlatformClassH(objeto){
      return util.getPlatformClassH(objeto);
    },

    removeFromStore(index) {
      this.notificacionesAlerta.splice(index, 1);
    },

    nuevaNotificacionAlerta(notificacion) {
      // comprueba si la notificacion tiene el formato esperado (solo los campos que se utilizarán)...
      let nd = notificacion.data;
      if (nd != undefined) nd = notificacion.data.mensaje;
      if (nd === undefined) {
        console.log('nuevaNotificacionAlerta(notificacion) => Error: La Notificacion recibida no tiene el formato esperado!!');
        return;
      }
      // solo almaceno las 50 ultimas notificaciones de Alerta (FIFO)
      if (this.notificacionesAlerta.length>=50)
        this.notificacionesAlerta.splice(0, 25);
      this.notificacionesAlerta.push(notificacion);
    },
    texto2HTML (texto) {
      return texto.replace(/(?:\r\n|\r|\n)/g, '<br />');
    },
    eventoNotificacionRecibida (notificacion) {
      this.nuevaNotificacionAlerta(notificacion);
    },
    eventoInteraccionNotificacion (notificacion) {
      this.nuevaNotificacionAlerta(notificacion['notification']);
    },

   
  },

  mounted () {
    Notificaciones.configurarEventoNotificacionRecibida (this.eventoNotificacionRecibida);
    Notificaciones.configurarEventoInteraccionConNotificacion (this.eventoInteraccionNotificacion);
    this.mounted = true;
  },

  created() {
    this.esIOS = util.isIOS();

    
  }
  
};
</script>

<style>
.cerrarSesion {
  color: #999999 !important;
}
.cssios {
  margin-top:60px
}
.cssnormal {
  margin-top:5px
}
.acssiosh {
  height:100px
}
.acssnormalh {
  height:70px
}
</style>
